import { handleActions } from 'redux-actions';
import {
  AccountActionsEnum,
  SetPasswordError,
  SetPasswordSuccess,
  SetPasswordTokenSuccess,
} from '../actions';
import { IAccountResponseError, ISetPasswordToken } from '../../account.data';
import { ROUTER_REQUEST } from '@ngrx/router-store';

export interface IState {
  error: Error | IAccountResponseError;
  message: string;
  processing: boolean;
  token: ISetPasswordToken;
}

export const initialState: IState = {
  error: null,
  message: null,
  processing: false,
  token: null,
};

const reducerFn = handleActions(
  {
    // clear the error when user navigates to a different route
    [ROUTER_REQUEST]: function (state: IState) {
      return {
        ...state,
        error: null,
        message: null,
      };
    },
    [AccountActionsEnum.SET_PASSWORD_EMAIL]: function (state: IState) {
      return {
        ...state,
        message: null,
        error: null,
        processing: true,
      };
    },
    [AccountActionsEnum.SET_PASSWORD_SUCCESS]: function (
      state: IState,
      { payload }: SetPasswordSuccess
    ) {
      return {
        ...state,
        message: payload.message,
        error: null,
        processing: false,
      };
    },
    [AccountActionsEnum.SET_PASSWORD_ERROR]: function (
      state: IState,
      { payload }: SetPasswordError
    ) {
      return {
        ...state,
        error: payload.error,
        message: null,
        processing: false,
      };
    },
    [AccountActionsEnum.SET_PASSWORD_TOKEN_SUCCESS]: function (
      state: IState,
      { payload }: SetPasswordTokenSuccess
    ) {
      return {
        ...state,
        error: null,
        processing: false,
        token: payload,
      };
    },
    [AccountActionsEnum.SET_PASSWORD_TOKEN_ERROR]: function (
      state: IState,
      { payload }: SetPasswordError
    ) {
      return {
        ...state,
        error: payload.error,
        message: null,
        processing: false,
      };
    },
    [AccountActionsEnum.UPDATE_PASSWORD_TOKEN]: function (state: IState) {
      return {
        ...state,
        error: null,
        processing: true,
      };
    },
    [AccountActionsEnum.UPDATE_PASSWORD_TOKEN_SUCCESS]: function (
      state: IState
    ) {
      return {
        ...state,
        error: null,
        processing: false,
        token: null,
      };
    },
  } as any,
  initialState
);

export function reducer(state: IState, action: any) {
  return reducerFn(state, action);
}
